import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ko from './ko.js'
import en from './en.js'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: navigator.language,
  messages: {
    en: en,
    ko: ko
  }
})



// WEBPACK FOOTER //
// ./src/i18n/index.js